import {take, filter} from 'rxjs/operators';
import {Component, Input, ViewChild} from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { Account } from "sharedFeatures/sharedModels";
import {ComboComponent, ItemData} from "sharedFeatures/form";
import { BillingDetails } from "sharedFeatures/sharedModels";
import { AccountService, BillingService } from "sharedFeatures/sharedServices";
import { ProfileService } from "sharedFeatures/sharedServices";
import { CountriesListDTO } from 'sharedGuiSmall/sharedModels/countriesDto';
import { IBillingDetails } from "sharedFeatures/sharedServices/Responses/billing.index";

@Component({
    selector: 'billing-details-body',
    templateUrl: './billing-details-body.component.html',
    styleUrls: ['./billing-details-body.component.less']
})
export class BillingDetailsBodyComponent {

    NAText = $localize`N/A`;

    @Input()
    Details: BillingDetails;

    OldDetails: BillingDetails;

    @select(['account', 'accountData'])
    readonly accountData$!: Observable<Account>;
    
    @ViewChild('countryCombo')
    countryCombo!: ComboComponent;

    initialCountryId: number = 0;

    countries: Array<ItemData> = [{ id: 1, value: this.NAText, disabled: true }];

    constructor(private billingService: BillingService, private accountService: AccountService, private profileService: ProfileService) {

        this.Details = new BillingDetails();
        this.OldDetails = new BillingDetails();
    }

    ngOnInit() {
        localStorage.setItem('route', 'undefined');
        this.subscribeReduxStore();

        if (this.profileService.countriesPromise)
            this.profileService.countriesPromise.then((data: CountriesListDTO) => {
                //if (self.chDet['destroyed']) return;
                if (typeof (data.data.Countries) == "undefined") return;
                this.countries = this.getComboItems(data.data.Countries);
         });

    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.accountData$.pipe(
            filter(x => !!x),
            take(1))
            .subscribe((accountData: Account) => {
                if (accountData) {
                    if (accountData.customerRef > 0) {
                        this.billingService.LoadBillingDetails(accountData.customerRef.toString())
                            .then((data: IBillingDetails) => {
                                this.Details = new BillingDetails(data);
                                this.OldDetails = Object.assign({}, this.Details);
                            });
                    }
                }
            });
    }

    getComboItems(itemsDto: any): ItemData[] {
        var result = new Array();
        if (itemsDto)
            for (var i = 0; i < itemsDto.length; i++) {
                var item = new ItemData();
                item.id = itemsDto[i].ID;
                item.value = itemsDto[i].Name;

                if (item.id == 1)
                    item.disabled = true;

                result.push(item);
            }

        return result;
    }

    onFirstNameChanged(value: string) {
        this.Details.FirstName = value;
    }

    onLastNameChanged(value: string) {
        this.Details.LastName = value;
    }

    onCompanyNameChanged(value: string) {
        this.Details.CompanyName = value;
    }

    onVatIdChanged(value: string) {
        this.Details.VatId = value;
    }

    onPhoneChanged(value: string) {
        this.Details.Phone = value;
    }

    onCountryFocusOut(event: FocusEvent): void {
        let curVal = (event.target as HTMLInputElement).value;
        if (curVal === undefined || !this.countryCombo || !this.countryCombo.boundlist || !this.countryCombo.boundlist.BoundListData) return;

        let countryFromList = this.countryCombo.boundlist.BoundListData.find(x => x.value.toLowerCase().indexOf(curVal.toLowerCase()) !== -1);
        if (countryFromList)
            this.onCountryChanged(countryFromList.id);
        else {
            if (this.initialCountryId)
                this.onCountryChanged((this.initialCountryId+''));
            else
                this.onCountryChanged('0');
        }
    }

    onCountryChanged(value: string) {
        let country: ItemData | undefined = this.countries.find(x => x.id == parseInt(value));

        console.log('to country ', value, this.Details.Country_ID);

        if (country === undefined) return;

        this.Details.Country_ID = country.id;
        this.Details.Country_Name = country.value;
    }

    onAddress1Changed(value: string) {
        this.Details.Address1 = value;
    }

    onAddress2Changed(value: string) {
        this.Details.Address2 = value;
    }

    onCityChanged(value: string) {
        this.Details.City = value;
    }

    onZipChanged(value: string) {
        this.Details.Zip = value;
    }

    onCountyChanged(value: string) {
        this.Details.County = value;
    }

    HasChanges(): boolean {
        return !this.Details.IsEqual(this.OldDetails);
    }

    saveClick() {
        if (!this.HasChanges()) return;

        this.billingService.SaveBillingDetails(this.Details).then(() => {
            Object.assign(this.OldDetails, this.Details);
        });
    }
}
